import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import { metaTag } from "../Library/commomLib";
import Preloader from "../Components/Common/Preloader";
const NewBranchComponent = React.lazy(() => import("../Components/RootComponents/NewBranchComponent"));
const BlogDetailsPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <NewBranchComponent />
      </Suspense>
    </Fragment>
  );
};

export default BlogDetailsPage;
